export const CHANNELS = {
  NOTIFICATION: 'NotificationChannel',
  CONVERSATION: 'ConversationChannel',
  INBOX: 'InboxChannel',
};